import React from 'react'
import classNames from "classnames"
import "./styles.css"

const CustomDrawer = (props) => {
    return (
        <div className={classNames("custom-drawer", { open: props.show })}>
            {props.children}
        </div>
    )
}

export default CustomDrawer;